import type { PinSearchTermOption } from './add-pin/add-pin-modal';

export const convertToKeyPhraseInputFormat: (keyPhraseValues: string[]) => PinSearchTermOption[] = (
	keyPhraseValues: string[],
): PinSearchTermOption[] =>
	keyPhraseValues.map((keyPhraseValue) => ({
		label: keyPhraseValue,
		value: keyPhraseValue,
	}));
